<template>
  <el-dialog
    append-to-body
    width="600px"
    title="积分设置"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="120px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-card>
        <div
          slot="header"
          style="display: flex; justify-content: space-between"
        >
          <div>需求端积分规则</div>
          <div>1积分等于{{ info.rate }}元</div>
        </div>
        <el-form-item prop="login" label="登录">
          <el-input placeholder="请输入" v-model="form.data.login" clearable>
            <span slot="suffix">积分/日</span>
          </el-input>
        </el-form-item>
        <el-form-item prop="check_worker" label="选择师傅">
          <el-input
            placeholder="请输入"
            v-model="form.data.check_worker"
            clearable
          >
            <span slot="suffix">积分/次</span>
          </el-input>
        </el-form-item>
        <el-form-item prop="appraise" label="评价师傅">
          <el-input placeholder="请输入" v-model="form.data.appraise" clearable>
            <span slot="suffix">积分/次</span>
          </el-input>
        </el-form-item>
      </el-card>
      <el-card>
        <div slot="header">积分消耗规则</div>
        <el-form-item prop="view_phone" label="查看师傅电话">
          <el-input
            placeholder="请输入"
            v-model="form.data.view_phone"
            clearable
          >
            <span slot="suffix">积分/次</span>
          </el-input>
        </el-form-item>
      </el-card>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >保存</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      form: {
        loading: false,
        data: {
          view_phone: "",
          login: "",
          check_worker: "",
          appraise: "",
        },
        rules: {
          view_phone: [{ required: true, message: "必填", trigger: "change" }],
          login: [{ required: true, message: "必填", trigger: "change" }],
          check_worker: [
            { required: true, message: "必填", trigger: "change" },
          ],
          appraise: [{ required: true, message: "必填", trigger: "change" }],
        },
      },
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.info = row;
      this.form.data = {
        view_phone: row.view_phone || "",
        login: row.login || "",
        check_worker: row.check_worker || "",
        appraise: row.appraise || "",
      };
    },
    reset(done) {
      this.form.data = { replenish_desc: "" };
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let _param = {
            ...this.form.data,
          };
          let apiUrl = "/admin/flex_config/setIntegral";
          this.$http
            .post(apiUrl, _param)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("保存成功");
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
